/**
 * Helpers for shared {@link gridState.filterAttributes} used across Global Search
 * and Workdesk grids. Workdesk flows (e.g. My Placements) often persist filters
 * without `associatedGridName`, which previously leaked chips onto Tasks Search.
 * ADO 506080 (Bug 1).
 */

type FilterAttributesLike = {
  filters?: unknown;
  associatedGridName?: string | null;
} | null | undefined;

export const filterAttributesHaveValues = (filterAttributes: FilterAttributesLike): boolean => {
  const filters = filterAttributes?.filters;
  if (!filters) return false;
  if (Array.isArray(filters)) return filters.length > 0;
  if (typeof filters === 'object') return Object.keys(filters).length > 0;
  return false;
};

/** True when persisted filters were written for this grid tag. */
export const filterAttributesBelongToGrid = (
  filterAttributes: FilterAttributesLike,
  gridTag: string,
): boolean => {
  if (!filterAttributesHaveValues(filterAttributes)) return true;
  return filterAttributes?.associatedGridName === gridTag;
};

/** Clear foreign filters when entering a grid (e.g. Tasks after Workdesk Placements). */
export const shouldClearForeignFiltersOnGridEntry = (
  filterAttributes: FilterAttributesLike,
  gridTag: string,
): boolean =>
  filterAttributesHaveValues(filterAttributes) &&
  filterAttributes?.associatedGridName !== gridTag;
